import { ConfigProvider, SelectProps as AntdSelectProps, Select as AntdSelect } from 'antd';
import { useTheme } from '../../theme/ThemeContext';

export type SelectProps = AntdSelectProps & { 'data-test'?: string };

const Select: React.FC<SelectProps> = ({ ...props }) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdSelect {...props} data-test={props['data-test']} data-asper-slider />
        </ConfigProvider>
    );
};

export default Select;
